import { api } from "@/lib/api";

// Public GETs (no auth)
export const getBanner = () => api.get("/content/banner").then((r) => r.data);
export const getServices = () => api.get("/content/services").then((r) => r.data);
export const getRates = () => api.get("/content/rates").then((r) => r.data);
export const getTestimonials = () =>
  api.get("/content/testimonials").then((r) => r.data);
export const getGallery = () => api.get("/content/gallery").then((r) => r.data);
export const getAddons = () => api.get("/content/addons").then((r) => r.data);

// Admin (auth required — axios already has withCredentials)
export const putBanner = (payload) =>
  api.put("/content/banner", payload).then((r) => r.data);

const crud = (base) => ({
  list: () => api.get(base).then((r) => r.data),
  create: (p) => api.post(base, p).then((r) => r.data),
  update: (id, p) => api.put(`${base}/${id}`, p).then((r) => r.data),
  remove: (id) => api.delete(`${base}/${id}`).then((r) => r.data),
});

export const servicesApi = crud("/content/services");
export const ratesApi = crud("/content/rates");
export const testimonialsApi = crud("/content/testimonials");
export const galleryApi = crud("/content/gallery");
export const addonsApi = crud("/content/addons");

// Analytics + messages (admin)
export const getAnalytics = (params = {}) =>
  api.get("/analytics/leads", { params }).then((r) => r.data);
export const listMessages = () => api.get("/messages").then((r) => r.data);
